const __ISS_API_BASE_URI = "/api/";

export const IssGetGearById = (esid, cfr, id, uri, callback) => {

    let URL = __ISS_API_BASE_URI + uri + id;

    const requestOptions = {
        method: 'GET',
        headers: {'Content-Type': 'application/x-www-form-urlencoded',
            'Access-Control-Allow-Origin': '*',
            'sid': esid,
            'cfr': cfr
        }
    };

    fetch(URL,requestOptions)
        .then(function (response) {
            // console.log(response)
            return response.json();
        })
        .then(function (Gears) {
            let d = Object.keys(Gears).map((key) => Gears[key]);
            // console.log("DATA GEAR: "+JSON.stringify(d[0]));
            callback(d[0]);
            return(d[0]);
        });
}

